import { Add } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, TextField, Typography } from '@mui/material';
import { Container } from '@mui/system';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { AppModels, AppState, CompanyAttrs, brandNewCompany, companySelector, companySlice, saveModel } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { useSession } from '../../libraries/SessionProvider';
import { appStore } from '../../store';
import { ContactLoader, RelatedContactLoader } from '../AppItems';
import { MasterViewPage } from '../MasterPage';
import { AddCompany } from './AddCompany';

export const Companies = () => {
    return <MasterViewPage>
        <MainSimpleViewLoader
            path='company/list'>
            <LoadedCompanies />
        </MainSimpleViewLoader>
    </MasterViewPage>;
};

const MainContactCell = (props: { relatedContactId: ModelId; }) => {
    return <RelatedContactLoader id={props.relatedContactId} render={(relatedContact => {
        return <ContactLoader id={relatedContact.contactId} render={contact => {
            return <>{contact.name} ({relatedContact.label})</>;
        }} />;
    })} />;
};

const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
        field: 'name',
        headerName: "Nom de la compagnie",
        flex: 1,
    },
    {
        field: 'code',
        headerName: 'Code court',
        flex: 1
    },
    {
        field: 'mainContactId',
        headerName: 'Contact principal',
        renderCell: (params) => {
            return params.value ? <MainContactCell relatedContactId={params.value} /> : null;
        },
        flex: 1
    },
    {
        field: 'website',
        headerName: 'Site Internet',
        flex: 1
    },
];

const LoadedCompanies = () => {
    const companies = useSelector((state: AppState) => companySelector.selectAll(state));
    const navigate = useNavigate();
    const { isSuperAdmin } = useSession();
    const [createCompany, setCreateCompany] = React.useState(false);
    const [quickCreating, setQuickCreating] = React.useState(false);
    const [newCompanyName, setNewCompanyName] = React.useState('');
    const quickCreate = async () => {

        if (newCompanyName !== '') {
            setQuickCreating(true);

            const quickCompany: CompanyAttrs = {
                ...brandNewCompany,
                name: newCompanyName
            };
            const response = await saveModel(AppModels.companies, quickCompany);
            appStore.dispatch(companySlice.actions.addOne(response));
            setNewCompanyName('');
            setQuickCreating(false);
        }
    };

    return <>
        {createCompany && <AddCompany onClose={() => { setCreateCompany(false); }} />}
        <Container maxWidth={false}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant='h1'>Compagnies</Typography>
                    {isSuperAdmin && <Grid container spacing={1}>
                        <Grid item sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                            <Button size='small' variant='contained' onClick={() => setCreateCompany(true)}>Nouvelle compagnie</Button>
                            <TextField
                                size='small'
                                placeholder='Nom'
                                value={newCompanyName}
                                onChange={(event) => {
                                    setNewCompanyName(event.target.value);
                                }}
                                onKeyDown={(e) => (
                                    e.key === 'Enter' && newCompanyName && !quickCreating && quickCreate()
                                )}
                                InputProps={{
                                    endAdornment: <IconButton color='primary' size='small' disabled={newCompanyName === '' || quickCreating} onClick={quickCreate}><Add /></IconButton>
                                }}
                            />
                        </Grid>
                    </Grid>}
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ height: 400, width: '100%', backgroundColor: 'white' }}>
                        <DataGrid
                            density='compact'
                            onRowClick={(params, _event) => {
                                navigate('/company/' + params.row.id);
                            }}
                            rows={companies}
                            columns={columns}
                        />
                    </Box>
                </Grid>
            </Grid>

        </Container>
    </>;
};
